import { keys, reduce, isNil, isEmpty } from 'lodash';
import { Validations, Helpers } from '@utils/helpers';
import { IError } from '@utils/useForm';
import { DeclarationForm } from '@models/MLTC_R3/Declaration.model';

export const validateDeclaration = (values: DeclarationForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateDeclarationField(values, field) };
  }, {});
  return errors;
}

export const validateDeclarationField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'summary':
    case 'term':
    case 'declaration':
    case 'required1':
    case 'required2':
    case 'required3':
      if (isNil(value) || value === false) {
        error = { isValid: false };
      }
      break;
  }
  return error;
}
